import {axiosRequest} from "./apiBase";
import {UserCategoryResult} from "../common/models/userResults/UserCategoryResult.model";
import CategoryAnswer from "../common/models/answer/categoryAnswer.model";
import {StarSignDetailsModel} from "../common/models/userResults/starSignDetails.model";

export const userCategoryResultCalculatePersona = async (categoryAnswerIds : number[] ): Promise<UserCategoryResult[]> => {
    return axiosRequest(
        "POST",
        "userCategoryResult/calculatePersona",
        categoryAnswerIds
    );
};

export const calculateQuizResults = async (quizId: number, quizQuestionAnswerIds: number[]) : Promise<CategoryAnswer[]> => {
    return axiosRequest(
        "POST",
        `userCategoryResult/calculateQuizResults/${quizId}`,
        quizQuestionAnswerIds
    );
};

export const calculateStarSignResults = async (starSignDetails: StarSignDetailsModel) : Promise<CategoryAnswer[]> => {
    return axiosRequest(
        "POST",
        `userCategoryResult/calculateStarSignResults`,
        starSignDetails
    );
};
